import { graphql, useFragment } from 'react-relay';
import PropTypes from 'prop-types';

// components
import { SbSharedRefineMenuMultiSelectSearch } from '../SbSharedRefineMenuMultiSelect/SbSharedRefineMenuMultiSelectSearch.tsx';

const viewerFragment = graphql`
    fragment SbSharedRefineMenuFilterMaterial_viewer on Viewer {
        ...SbSharedRefineMenuMultiSelectSearch_viewer
    }
`;
const itemSearchFragment = graphql`
    fragment SbSharedRefineMenuFilterMaterial_itemSearch on ItemSearchQueryConnection {
        ...SbSharedRefineMenuMultiSelectSearch_itemSearch
    }
`;
export const SbSharedRefineMenuFilterMaterial = ({
    viewer: viewerRef,
    itemSearch: itemSearchRef,
    collapsedItemCount,
    filterName,
    values,
    showSearchBar,
    trackingOptions,
}) => {
    const viewer = useFragment(viewerFragment, viewerRef);
    const itemSearch = useFragment(itemSearchFragment, itemSearchRef);
    return (
        <SbSharedRefineMenuMultiSelectSearch
            viewer={viewer}
            itemSearch={itemSearch}
            filterName={filterName}
            collapsedItemCount={collapsedItemCount}
            values={values}
            showSearchBar={showSearchBar}
            trackingOptions={trackingOptions}
        />
    );
};

SbSharedRefineMenuFilterMaterial.propTypes = {
    viewer: PropTypes.object.isRequired,
    itemSearch: PropTypes.object.isRequired,
    filterName: PropTypes.string.isRequired,
    collapsedItemCount: PropTypes.number,
    values: PropTypes.array.isRequired,
    showSearchBar: PropTypes.bool,
    trackingOptions: PropTypes.object,
};
